import { render, staticRenderFns } from "./institutional-index.vue?vue&type=template&id=3b9a9f56&scoped=true"
import script from "./institutional-index.vue?vue&type=script&lang=js"
export * from "./institutional-index.vue?vue&type=script&lang=js"
import style0 from "./institutional-index.vue?vue&type=style&index=0&id=3b9a9f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9a9f56",
  null
  
)

export default component.exports